// require('es6-promise').polyfill();
import Vue from "vue";
import App from "./App";
//先引入第三方组件
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//后引入router
import router from "./router";
import store from "./store";
import VueJsonp from "vue-jsonp";
import 'video.js/dist/video-js.css' //videojs样式
// Esp通用组件
import EspCommon from "./components/common";
// 全局变量
import EspConstant from "./utils/constant";
import EspService from "./utils/service"
// 全局样式
import './styles/global.css'
import "./styles/element-ui.scss";
import './assets/icon/iconfont.css'
import './assets/uiIcon/iconfont.css'
import './assets/otherIcon/iconfont.css'
// import 'normalize.css/normalize.css'
// import 'babel-polyfill';
import i18n from './locales'

import SerialPortPlugin from './plugin/serial-port';

EspCommon.forEach(component => {
  Vue.component(component.name, component);
});

window.appGlobal = {
  sharedData: {},
  setData: function(key, value) {
    this.sharedData[key] = value;
  },
  getData: function(key) {
    return this.sharedData[key];
  }
};

Vue.prototype.espConstant = EspConstant;
Vue.prototype.espService = EspService;

// // 安装串口插件
Vue.use(SerialPortPlugin);

Vue.use(ElementUI, {size: "small", zIndex: 3000});
Vue.use(VueJsonp);
Vue.config.productionTip = false;

// Vue.use(QuillEditor)

// 千分位
Vue.filter("toNumberZero", function (data) {
  if (data == null || data == undefined || data == "" || data == 0) {
    return 0.00;
  }
  if (typeof (data) === "number") {
    return (data).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  }
  return data;
});

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: {App},
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js